function getApiBaseUrl() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl
    ? window.__MC__CONFIG__.apiUrl
    : "";
}

function buildAuthHeaders(token) {
  var headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
  if (window.__MC__CONFIG__ && window.__MC__CONFIG__.headers) {
    Object.assign(headers, window.__MC__CONFIG__.headers);
  }
  return headers;
}

function isResponseOk(data) {
  return data && data.code == 200;
}

function escapeHtml(str) {
  return String(str == null ? "" : str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function formatInteger(num) {
  var value = parseFloat(num);
  if (isNaN(value)) return num == null ? "" : String(num);
  return String(Math.round(value));
}

function formatUsDate(timestamp) {
  var ts = Number(timestamp);
  if (!ts) return "-";
  if (ts < 1e12) ts = ts * 1000;
  var date = new Date(ts);
  var options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return date.toLocaleString("en-US", options).replace(",", "");
}

function formatRankOrdinal(rank) {
  var r = parseInt(rank, 10);
  if (isNaN(r)) return String(rank);
  if (r === 1) return "1<sup>st</sup>";
  if (r === 2) return "2<sup>nd</sup>";
  if (r === 3) return "3<sup>rd</sup>";
  return String(r);
}

function getEmptyIconSvg() {
  return (
    '<svg viewBox="0 0 64 64" fill="none" aria-hidden="true" focusable="false">' +
    '<rect x="14" y="10" width="36" height="44" rx="4" stroke="#d4ceca" stroke-width="2"/>' +
    '<line x1="22" y1="22" x2="42" y2="22" stroke="#d4ceca" stroke-width="2" stroke-linecap="round"/>' +
    '<line x1="22" y1="32" x2="42" y2="32" stroke="#d4ceca" stroke-width="2" stroke-linecap="round"/>' +
    '<line x1="22" y1="42" x2="34" y2="42" stroke="#d4ceca" stroke-width="2" stroke-linecap="round"/>' +
    "</svg>"
  );
}

function getEmptyIconHtml(iconUrl) {
  var svg = getEmptyIconSvg();
  if (!iconUrl) {
    return svg;
  }
  return (
    '<img src="' +
    escapeHtml(iconUrl) +
    '" alt="" loading="lazy" onerror="this.style.display=\'none\'; this.nextElementSibling.style.display=\'block\';">' +
    '<span style="display:none;">' +
    svg +
    "</span>"
  );
}

class BrandM26VitalityStats extends HTMLElement {
  constructor() {
    super();
    this.state = "loading";
    this.currentToken = "";
    this.loadedToken = "";
    this.loadingInfo = false;
    this.breakdownPage = 1;
    this.breakdownPageSize = 10;
    this.breakdownLoading = false;
    this.breakdownHasMore = true;
    this.rankingsLoading = false;
    this.config = {
      activityType: this.dataset.activityType || "page_26BrandDay",
      loginText: this.dataset.loginText || "Log in to view",
      noRankText: this.dataset.noRankText || "No Rank Yet",
      scoreUnit: this.dataset.scoreUnit || "pts",
      infoUrl: this.dataset.infoUrl || "",
      emptyIcon: this.dataset.emptyIcon || "",
      breakdownEmptyIcon: this.dataset.breakdownEmptyIcon || "",
      rankingsEmptyIcon: this.dataset.rankingsEmptyIcon || "",
      avatarUrl: this.dataset.avatarUrl || "",
      breakdownEmptyTitle: this.dataset.breakdownEmptyTitle || "No records yet",
      breakdownEmptySubtitle:
        this.dataset.breakdownEmptySubtitle ||
        "Your earned rewards scores will appear here.",
      rankingsEmptyTitle: this.dataset.rankingsEmptyTitle || "No rankings yet",
      rankingsEmptySubtitle:
        this.dataset.rankingsEmptySubtitle ||
        "The leaderboard will appear here.",
    };
  }

  connectedCallback() {
    this.scoreValueEl = this.querySelector("[data-bv-score-value]");
    this.rankValueEl = this.querySelector("[data-bv-rank-value]");
    this.scoreNumberEl = this.querySelector("[data-bv-score]");
    this.rankNumberEl = this.querySelector("[data-bv-rank]");
    this.loginBtns = this.querySelectorAll("[data-bv-login-btn]");
    this.dialogTriggers = this.querySelectorAll("[data-bv-stats-open]");
    this.sid = this.dataset.sectionId || "";
    this.breakdownBody = document.querySelector(
      "#breakdown-dialog-" + this.sid + " .brandm26-vitality__dialog-body",
    );
    this.rankingsBody = document.querySelector(
      "#rankings-dialog-" + this.sid + " .brandm26-vitality__dialog-body",
    );

    this.onBreakdownScroll = this.handleBreakdownScroll.bind(this);

    this.bindEvents();

    var token = this.getToken();
    if (!token) {
      this.setGuestState();
    } else {
      this.loadInfo(token);
    }

    this.onLoginHandler = function (e) {
      var newToken =
        e.detail && e.detail.token ? e.detail.token : this.getToken();
      if (newToken) this.loadInfo(newToken);
    }.bind(this);
    document.addEventListener("LUTE:AUTH:LOGIN", this.onLoginHandler);
  }

  disconnectedCallback() {
    if (this.onLoginHandler) {
      document.removeEventListener("LUTE:AUTH:LOGIN", this.onLoginHandler);
    }
  }

  bindEvents() {
    var self = this;

    this.loginBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.openLoginDialog();
      });
    });

    this.dialogTriggers.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (self.state === "guest") {
          self.openLoginDialog();
          return;
        }
        var dialogType = btn.getAttribute("data-bv-stats-open");
        self.openDialog(dialogType);
      });
    });
  }

  openDialog(type) {
    var id = type + "-dialog-" + this.sid;
    var dialog = document.getElementById(id);
    if (!dialog) return;
    dialog.style.display = "";
    document.body.style.overflow = "hidden";
    var closeBtn = dialog.querySelector("[data-bv-close]");
    if (closeBtn) closeBtn.focus();

    if (type === "breakdown") {
      this.loadBreakdown(true);
    } else if (type === "rankings") {
      this.loadRankings();
    }
  }

  openLoginDialog() {
    var loginDialog = document.querySelector("login-dialog");
    if (loginDialog && typeof loginDialog.open === "function") {
      var baseUrl = window.location.href.split("#")[0];
      var redirect = this.id ? baseUrl + "#" + this.id : window.location.href;
      loginDialog.open(null, {
        activityType: this.config.activityType,
        mustAgreeEmail: true,
        redirect: redirect,
      });
    }
  }

  getToken() {
    var cookieName = window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName;
    if (!cookieName) return null;
    var match = document.cookie.match(new RegExp(cookieName + "=([^;]+)"));
    return match ? match[1] : null;
  }

  setGuestState() {
    this.state = "guest";
    this.currentToken = "";
    this.loadedToken = "";
    if (this.scoreValueEl) this.scoreValueEl.style.display = "none";
    if (this.rankValueEl) this.rankValueEl.style.display = "none";
    this.loginBtns.forEach(function (btn) {
      btn.style.display = "inline-flex";
    });
    this.clearDialogContent();
  }

  setLoggedInState(data) {
    this.state = "loggedIn";
    this.loginBtns.forEach(function (btn) {
      btn.style.display = "none";
    });

    var score =
      data && typeof data.score === "number"
        ? data.score
        : data && data.score != null
          ? parseFloat(data.score) || 0
          : 0;
    var rank = data && data.rank != null ? String(data.rank) : "";

    if (this.scoreValueEl) {
      if (this.scoreNumberEl) {
        this.scoreNumberEl.textContent = formatInteger(score);
      }
      this.scoreValueEl.style.display = "";
    }

    if (this.rankValueEl) {
      var isNoRank = !rank || rank === "0";
      if (this.rankNumberEl) {
        this.rankNumberEl.textContent = isNoRank
          ? this.config.noRankText
          : rank;
      } else {
        this.rankValueEl.textContent = isNoRank ? this.config.noRankText : rank;
      }
      if (isNoRank) {
        this.rankValueEl.classList.add(
          "brandm26-vitality__rank-value--no-rank",
        );
      } else {
        this.rankValueEl.classList.remove(
          "brandm26-vitality__rank-value--no-rank",
        );
      }
      this.rankValueEl.style.display = "";
    }
  }

  clearDialogContent() {
    this.renderDialogPlaceholder(
      this.breakdownBody,
      "Log in to view your rewards score breakdown.",
    );
    this.renderDialogPlaceholder(
      this.rankingsBody,
      "Log in to view the full rankings.",
    );
  }

  renderDialogPlaceholder(body, message) {
    if (!body) return;
    body.innerHTML =
      '<div class="brandm26-vitality__dialog-placeholder">' +
      escapeHtml(message) +
      "</div>";
  }

  async loadInfo(token) {
    if (this.loadingInfo) return;
    if (
      this.loadedToken &&
      this.loadedToken === token &&
      this.state === "loggedIn"
    ) {
      return;
    }

    this.loadingInfo = true;
    this.currentToken = token;

    var baseUrl = getApiBaseUrl();
    if (!baseUrl) {
      this.loadingInfo = false;
      this.setLoggedInState({ score: 0, rank: null });
      return;
    }

    try {
      var res = await fetch(baseUrl + "/api/station/brandDay2026/vitality/me", {
        method: "GET",
        headers: buildAuthHeaders(token),
      });
      var data = await res.json();

      if (isResponseOk(data) && data.result) {
        var result = data.result;
        this.loadedToken = token;
        var score = result.myVitality != null ? result.myVitality : 0;
        var rank = null;
        if (score > 0) {
          rank =
            result.myRankDisplay != null
              ? result.myRankDisplay
              : result.myRank != null
                ? result.myRank
                : null;
        }
        this.setLoggedInState({
          score: score,
          rank: rank,
        });
      } else {
        this.setLoggedInState({ score: 0, rank: null });
      }
    } catch (error) {
      console.error("Load vitality info error:", error);
      this.setLoggedInState({ score: 0, rank: null });
    } finally {
      this.loadingInfo = false;
    }
  }

  handleBreakdownScroll(e) {
    if (this.breakdownLoading || !this.breakdownHasMore) return;
    var listEl = e.target;
    if (
      listEl &&
      listEl.scrollTop + listEl.clientHeight >= listEl.scrollHeight - 40
    ) {
      this.loadBreakdown(false);
    }
  }

  async loadBreakdown(reset) {
    if (this.breakdownLoading) return;
    if (reset) {
      this.breakdownPage = 1;
      this.breakdownHasMore = true;
    }
    if (!this.breakdownHasMore) return;

    this.breakdownLoading = true;
    this.setBreakdownLoading(true);

    var baseUrl = getApiBaseUrl();
    if (!baseUrl || !this.currentToken) {
      this.setBreakdownLoading(false);
      if (reset) this.renderBreakdownEmpty();
      this.breakdownLoading = false;
      return;
    }

    try {
      var isFirstPage = this.breakdownPage === 1;
      var pageSize = isFirstPage ? 20 : this.breakdownPageSize;
      var url =
        baseUrl +
        "/api/station/brandDay2026/vitality/detail?pageNum=" +
        this.breakdownPage +
        "&pageSize=" +
        pageSize;
      var res = await fetch(url, {
        method: "GET",
        headers: buildAuthHeaders(this.currentToken),
      });
      var data = await res.json();

      if (isResponseOk(data) && data.result) {
        var result = data.result;
        var list = Array.isArray(result.recordList) ? result.recordList : [];
        var total = typeof result.total === "number" ? result.total : 0;
        var loaded =
          (this.breakdownPage - 1) * this.breakdownPageSize + list.length;
        this.breakdownHasMore =
          total > 0 ? loaded < total : list.length >= pageSize;
        this.renderBreakdown(list, reset);
        if (isFirstPage) {
          this.breakdownPage = 3;
        } else {
          this.breakdownPage++;
        }
      } else {
        if (reset) this.renderBreakdownEmpty();
      }
    } catch (error) {
      console.error("Load breakdown error:", error);
      if (reset) this.renderBreakdownEmpty();
    } finally {
      this.setBreakdownLoading(false);
      this.breakdownLoading = false;
    }
  }

  setBreakdownLoading(show) {
    if (!this.breakdownBody) return;
    var el = this.breakdownBody.querySelector(
      ".brandm26-vitality__dialog-loading",
    );
    if (show) {
      if (!el) {
        el = document.createElement("div");
        el.className =
          "brandm26-vitality__dialog-loading brandm26-vitality__dialog-loading--bottom";
        el.textContent = "Loading...";
      }
      var listEl = this.breakdownBody.querySelector(
        ".brandm26-vitality__breakdown-list",
      );
      if (listEl) {
        listEl.appendChild(el);
      } else {
        this.breakdownBody.appendChild(el);
      }
    } else if (el) {
      el.remove();
    }
  }

  renderBreakdownEmpty() {
    if (!this.breakdownBody) return;
    this.breakdownBody.innerHTML =
      '<div class="brandm26-vitality__breakdown-head">' +
      "<span>Transaction Time</span>" +
      "<span>Source</span>" +
      "<span>Rewards Scores</span>" +
      "<span>Remark</span>" +
      "</div>" +
      '<div class="brandm26-vitality__empty">' +
      '<div class="brandm26-vitality__empty-icon">' +
      getEmptyIconHtml(
        this.config.breakdownEmptyIcon || this.config.emptyIcon,
      ) +
      "</div>" +
      '<p class="brandm26-vitality__empty-title">' +
      escapeHtml(this.config.breakdownEmptyTitle) +
      "</p>" +
      '<p class="brandm26-vitality__empty-subtitle">' +
      escapeHtml(this.config.breakdownEmptySubtitle) +
      "</p>" +
      "</div>";
  }

  renderBreakdown(list, reset) {
    if (!this.breakdownBody) return;

    if (reset) this.breakdownBody.innerHTML = "";

    if (reset && list.length === 0) {
      this.renderBreakdownEmpty();
      return;
    }

    var self = this;
    var head = this.breakdownBody.querySelector(
      ".brandm26-vitality__breakdown-head",
    );
    var listEl = this.breakdownBody.querySelector(
      ".brandm26-vitality__breakdown-list",
    );
    if (!head) {
      head = document.createElement("div");
      head.className = "brandm26-vitality__breakdown-head";
      head.innerHTML =
        "<span>Transaction Time</span>" +
        "<span>Source</span>" +
        "<span>Rewards Scores</span>" +
        "<span>Remark</span>";
      this.breakdownBody.appendChild(head);
    }
    if (!listEl) {
      listEl = document.createElement("div");
      listEl.className = "brandm26-vitality__breakdown-list";
      listEl.addEventListener("scroll", this.onBreakdownScroll);
      this.breakdownBody.appendChild(listEl);
    }

    list.forEach(function (item) {
      var row = document.createElement("div");
      row.className = "brandm26-vitality__breakdown-row";
      var time = formatUsDate(item.earnedTime);
      var source = self.formatBreakdownSource(item);
      var score = formatInteger(item.scores);
      var remark = item.remark || "-";
      row.innerHTML =
        "<span>" +
        escapeHtml(time) +
        "</span>" +
        "<span>" +
        escapeHtml(source) +
        "</span>" +
        "<span>" +
        escapeHtml(score) +
        "</span>" +
        "<span>" +
        escapeHtml(remark) +
        "</span>";
      listEl.appendChild(row);
    });

    var loadingEl = this.breakdownBody.querySelector(
      ".brandm26-vitality__dialog-loading",
    );
    if (loadingEl && listEl) {
      listEl.appendChild(loadingEl);
    }
  }

  formatBreakdownSource(item) {
    return item.rewardScoreSource || "";
  }

  async reportTaskEvent(eventType) {
    var baseUrl = getApiBaseUrl();
    if (!baseUrl || !this.currentToken) return;
    try {
      await fetch(
        baseUrl + "/api/station/activity/brandday-2026/point/task/report",
        {
          method: "POST",
          headers: buildAuthHeaders(this.currentToken),
          body: JSON.stringify({ eventType: eventType }),
        },
      );
    } catch (error) {
      console.error("Report task event error:", error);
    }
  }

  async loadRankings() {
    if (this.rankingsLoading) return;
    this.rankingsLoading = true;

    var baseUrl = getApiBaseUrl();
    if (!baseUrl || !this.currentToken) {
      this.renderRankingsEmpty();
      this.rankingsLoading = false;
      return;
    }

    try {
      var res = await fetch(
        baseUrl + "/api/station/brandDay2026/vitality/rank",
        {
          method: "GET",
          headers: buildAuthHeaders(this.currentToken),
        },
      );
      var data = await res.json();

      if (isResponseOk(data) && data.result) {
        var result = data.result;
        var list = Array.isArray(result.rankList) ? result.rankList : [];
        this.renderRankings(list, result);
        // 打开榜单后上报任务事件
        await this.reportTaskEvent(92);
      } else {
        this.renderRankingsEmpty();
      }
    } catch (error) {
      console.error("Load rankings error:", error);
      this.renderRankingsEmpty();
    } finally {
      this.rankingsLoading = false;
    }
  }

  renderRankingsEmpty() {
    if (!this.rankingsBody) return;
    this.rankingsBody.innerHTML =
      '<div class="brandm26-vitality__rankings-head">' +
      "<span>Rank</span>" +
      "<span>Profile Picture</span>" +
      "<span>Email</span>" +
      "<span>Rewards Score(pts)</span>" +
      "</div>" +
      '<div class="brandm26-vitality__empty">' +
      '<div class="brandm26-vitality__empty-icon">' +
      getEmptyIconHtml(this.config.rankingsEmptyIcon || this.config.emptyIcon) +
      "</div>" +
      '<p class="brandm26-vitality__empty-title">' +
      escapeHtml(this.config.rankingsEmptyTitle) +
      "</p>" +
      '<p class="brandm26-vitality__empty-subtitle">' +
      escapeHtml(this.config.rankingsEmptySubtitle) +
      "</p>" +
      "</div>";
  }

  renderRankings(list, result) {
    if (!this.rankingsBody) return;

    if (list.length === 0) {
      this.renderRankingsEmpty();
      return;
    }

    var html =
      '<div class="brandm26-vitality__rankings-head">' +
      "<span>Rank</span>" +
      "<span>Profile Picture</span>" +
      "<span>Email</span>" +
      "<span>Rewards Score(pts)</span>" +
      "</div>" +
      '<div class="brandm26-vitality__rankings-list">';

    var self = this;
    list.forEach(function (item) {
      var rank = item.rank || 0;
      var rankClass =
        rank >= 1 && rank <= 3
          ? "brandm26-vitality__rankings-row--top" + rank
          : "";
      var avatar = item.avatar || self.config.avatarUrl || "";
      var email = item.email || "-";
      var vitality = formatInteger(item.vitality);
      html +=
        '<div class="brandm26-vitality__rankings-row ' +
        rankClass +
        '">' +
        '<span class="brandm26-vitality__rankings-rank">' +
        formatRankOrdinal(rank) +
        "</span>" +
        '<span class="brandm26-vitality__rankings-avatar">' +
        (avatar
          ? '<img src="' + escapeHtml(avatar) + '" alt="" loading="lazy">'
          : '<span class="brandm26-vitality__rankings-avatar-placeholder"></span>') +
        "</span>" +
        '<span class="brandm26-vitality__rankings-email">' +
        escapeHtml(email) +
        "</span>" +
        '<span class="brandm26-vitality__rankings-score">' +
        escapeHtml(vitality) +
        "</span>" +
        "</div>";
    });
    html += "</div>";

    this.rankingsBody.innerHTML = html;
  }
}

if (!customElements.get("brandm26-vitality-stats")) {
  customElements.define("brandm26-vitality-stats", BrandM26VitalityStats);
}
